import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "text-4xl font-medium" }
const _hoisted_5 = { class: "flex mt-4 overflow-x-auto" }
const _hoisted_6 = { class: "w-full table-fixed" }
const _hoisted_7 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_8 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_9 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_10 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_11 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_12 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_13 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_14 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_15 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_16 = { class: "flex px-2 py-6 space-x-2 capitalize md:py-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_18 = { class: "px-2 py-2 capitalize" }
const _hoisted_19 = { class: "px-2 py-2 capitalize" }
const _hoisted_20 = { class: "px-2 py-2 capitalize" }
const _hoisted_21 = { class: "px-2 py-2 capitalize" }
const _hoisted_22 = { class: "px-2 py-2" }

import { ref } from "vue";
import { storeToRefs } from "pinia";

import TitleHeader from "../TitleHeader.vue";
import TimezoneSpan from "../TimezoneSpan.vue";
import RouterButton from "@/components/RouterButton.vue";

import ResourceCards from "../resources/ResourceCards.vue";
import AlertCard from "@/components/AlertCard.vue";
import ExternalLink from "@/components/ExternalLink.vue";
import UserBookingsTable from "../tables/UserBookingsTable.vue";

import api from "@/api/api";
import { Booking, Club, Resource } from "@/types";
import { useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'FacilitatorDashboard',
  async setup(__props) {

let __temp: any, __restore: any

const { user } = storeToRefs(useUserStore());
const role = userHasRole(user.value.roles, ["advanced-facilitator"]) ? "advanced-facilitator" : "advanced-facilitator-trainee";

const bookings = ref([] as Booking[]);
const showSurveyBanner = ref(false);
const traning_survey_url = ref("");

const resources = ref([] as Resource[]);

const clubs = ref([] as Club[]);

async function listClubs() {
  const response = await api.clubs.listClubs({
    page: 1,
  });
  clubs.value = response.data.clubs;
}

async function listResources() {
  const response = await api.resources.listResources({
    page: 1,
    role: role,
  });
  resources.value = response.data.resources;
  if (resources.value.length > 3) resources.value = resources.value.slice(0, 3);
}

/** Lists bookings where user is user_id on bookings */
bookings.value = (
  (
  ([__temp,__restore] = _withAsyncContext(() => api.bookings.listOwnBookings({
    page: 1,
  }))),
  __temp = await __temp,
  __restore(),
  __temp
)
).data.bookings;

async function getSurveys() {
  console.log("getSurveys facilitator");
  const response = await api.surveys.getCourseSurveyLinks();
  if (response.data.outstanding_surveys.length > 0) {
    traning_survey_url.value = response.data.training_survery_url;
    showSurveyBanner.value = true;
  }
}

if (user.value.has_brick_club_access) {
  (
  ([__temp,__restore] = _withAsyncContext(() => listClubs())),
  await __temp,
  __restore()
);
}

;(
  ([__temp,__restore] = _withAsyncContext(() => listResources())),
  await __temp,
  __restore()
);
;(
  ([__temp,__restore] = _withAsyncContext(() => getSurveys())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showSurveyBanner.value)
      ? (_openBlock(), _createBlock(AlertCard, {
          key: 0,
          type: "warning",
          style: {"margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("facilitator-banner")), 1),
              _createVNode(ExternalLink, {
                type: "button",
                href: traning_survey_url.value,
                label: _ctx.$t('complete-survey')
              }, null, 8, ["href", "label"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(TitleHeader, {
      title: _ctx.$t('welcome-back'),
      class: "mt-6"
    }, null, 8, ["title"]),
    _createVNode(UserBookingsTable, { limit: 5 }),
    (_unref(user).has_brick_club_access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("my-brick-clubs")), 1),
            _createVNode(RouterButton, {
              to: { name: 'Brick_Clubs' },
              type: "primary",
              class: "mt-5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("view-all-clubs-length-brick-clubs", [clubs.value.length])), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_7, [
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t(`name`)), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t(`date`)), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t(`facilitator`)), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t(`location`)), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t(`setting`)), 1),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t(`status`)), 1),
                  _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("actions")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clubs.value, (club) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "border-b border-gray-400 divide-x divide-gray-300",
                    key: club.id
                  }, [
                    _createElementVNode("td", _hoisted_15, _toDisplayString(club.name), 1),
                    _createElementVNode("td", _hoisted_16, [
                      _createVNode(TimezoneSpan, {
                        date: club.first_club_date,
                        locale: "en-GB",
                        "date-style": "short",
                        "time-style": "long",
                        showTime: false
                      }, null, 8, ["date"]),
                      _hoisted_17,
                      _createVNode(TimezoneSpan, {
                        date: club.last_club_date,
                        locale: "en-GB",
                        "date-style": "short",
                        "time-style": "long",
                        showTime: false
                      }, null, 8, ["date"])
                    ]),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(club.facilitator.first_name) + " " + _toDisplayString(club.facilitator.last_name), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(`${club.address_line_one} ${club.address_line_two !== null ? `, ${club.address_line_two}` : ""}, ${club.city}, ${club.postcode}, ${club.country}`), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(club.setting), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(club.status), 1),
                    _createElementVNode("td", _hoisted_22, [
                      _createVNode(_component_router_link, {
                        to: `/dashboard/clubs/${club.id}`,
                        class: "text-blue"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("manage-brick-club")), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(ResourceCards, {
      role: "facilitator",
      resources: resources.value.splice(0, 3)
    }, null, 8, ["resources"])
  ], 64))
}
}

})